module.exports = __webpack_public_path__ + "static/img/cab.154419d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/cab.png
// module id = wK1d
// module chunks = 53